import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAssistantList } from "../Redux/Slice/Assistant/AssistantsListSlice";
import { scheduleInstantCall } from "../Redux/Slice/Contacts/ScheduleInstantCallSlice";
import { Loader } from "../Common/Loader";
import { assignAssistantToFile } from "../Redux/Slice/Documents/AssignAssistantToFileSlice";
import MultiSelectDropdown from "../Common/MultiSelectDropdown";
import { debounce } from "../Common/debounce";

export const AssignAssistantToDocumentModal = (props) => {
  const dispatch = useDispatch();
  const [selectedAssistants, setSelectedAssistants] = useState([]);
  const { assistantsList: AssistantList, loading } = useSelector(
    (state) => state.assistants
  );
  const [isLoading, setIsLoading] = useState(false);

  const formatedAssistantList = useMemo(() => {
    let _formatedDataList = Array.isArray(AssistantList?.data)
      ? AssistantList?.data?.map((assistant) => {
          return { value: assistant?.id, label: assistant?.name };
        })
      : [];
    return _formatedDataList;
  }, [AssistantList, AssistantList?.data]);

  useEffect(() => {
    FetchAssistantsList();
  }, []);

  const FetchAssistantsList = async () => {
    await dispatch(getAssistantList({ text: "" }));
  };

  const handleChange = (selectedList) => {
    const selectedListIds = Array.isArray(selectedList)
      ? selectedList.map((item) => item?.value)
      : [];
    setSelectedAssistants(selectedListIds);
  };

  const handleSubmit = async () => {
    const body = {
      assistantIds: selectedAssistants,
      fileId: props?.fileId,
    };
    setIsLoading(true);
    try {
      const result = await dispatch(assignAssistantToFile(body));
      if (
        assignAssistantToFile.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        props.closePopup("success");
        setIsLoading(false);
      } else {
        props.closePopup("error", result?.payload?.error);
        setIsLoading(false);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading || loading) {
    return <Loader />;
  }

  return (
    <div className="modal modal--createAssistant modal--open">
      <div className="modal__dialog">
        <div className="modal__content modal__content--md">
          <div className="modal__header">
            <h1 className="modal__header--title">Assign Assistant</h1>
            <p className="para">
              Please select the details below to assign assistant to your file.
            </p>
          </div>
          <div className="modal__body  modal-body-left">
            <div className="scheduleCall scheduleCall--callingDetails">
              <div className="scheduleCall__row scheduleCall__row--divider"></div>
              <div className="scheduleCall__row">
                <div className="form__Field form__Field--full">
                  <label for="Chatbot" className="form__label">
                    Assistant
                  </label>
                  <MultiSelectDropdown
                    id="Chatbot"
                    name="chatbotId"
                    options={formatedAssistantList}
                    selectedValue={selectedAssistants}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="modal__footer">
            <div className="btn__group">
              <button onClick={props?.closePopup} className="btn btn__white">
                Cancel
              </button>
              <button
                className="btn btn__primary"
                disabled={!selectedAssistants.length}
                onClick={debounce(handleSubmit, 500)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};
